module.exports = __webpack_public_path__ + "static/DeicideCoverSliderImage-1a8279985448adbde52c5936cf77b008.jpeg";